import { createContext, useContext } from "react";
import { createPortal } from "react-dom";

// undefined keeps navigation inline; null waits for the form's navigation host.
export const PageNavigationContext = createContext(undefined);

export function PageNavigation({ children }) {
  const target = useContext(PageNavigationContext);
  if (target === undefined) return children;
  if (target === null) return null;

  return createPortal(
    <PageNavigationContext.Provider value={undefined}>
      {children}
    </PageNavigationContext.Provider>,
    target
  );
}